import { Shimmer, ShimmerElementType, Stack } from "@fluentui/react";

export function ApprovalFlowShimmer(): JSX.Element {
  return (
    <Stack grow tokens={{ childrenGap: 10 }}>
      <Shimmer
        shimmerElements={[
          { type: ShimmerElementType.line, width: "100%", height: 3 }
        ]}
      />

      <Stack horizontal horizontalAlign="space-between">
        {Array.from({ length: 8 }).map((_, index) => (
          <Shimmer
            key={index}
            styles={{ root: { padding: 5 } }}
            shimmerElements={[
              {
                type: ShimmerElementType.line,
                width: 40,
                height: 40
              }
            ]}
          />
        ))}
      </Stack>
    </Stack>
  );
}
